import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortalComponent } from './portal/portal.component';
import {
  PlatformComponent,
  CallbackComponent,
  ForbiddenComponent,
  UnauthorizedComponent,
  platformGuard,
  RoleGuard
} from 'aih-launchpad-core';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { PageTitleResolver } from './services/page-title.resolver';
import { Roles } from './constants/roles';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { AppWrapperComponent } from './app-wrapper/app-wrapper.component';

const routes: Routes = [
  {
    path: '',
    component: AppWrapperComponent,
    canActivate: [ platformGuard ],
    children: [
      {
        path: 'disclaimer',
        component: DisclaimerComponent,
        title: 'pageTitles.disclaimer',
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
        title: 'appName'
      },
      {
        path: 'home',
        component: PortalComponent,
        canActivate: [ AutoLoginPartialRoutesGuard ],
        title: 'appName',
      },
      {
        path: 'admin',
        canActivate: [ AutoLoginPartialRoutesGuard, RoleGuard],
        data: { roles: [ Roles.Admin, Roles.Reader ] },
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'cms',
        canActivate: [ AutoLoginPartialRoutesGuard, RoleGuard],
        // Gates the whole /cms subtree, so every CMS section role must be listed here as well as
        // on its own child route in cms.routes.ts — otherwise a user holding only that role is
        // bounced to /forbidden before the child routes are ever reached.
        data: { roles: [ Roles.NewsAdmin, Roles.FormBuilderAdmin, Roles.TeamMemberAdmin ] },
        loadChildren: () => import('./cms/cms.routes').then(m => m.CMS_ROUTES)
      },
    ]
  },
  { path: 'platform', component: PlatformComponent, title: 'appName', },
  { path: 'unauthorized', component: UnauthorizedComponent, title: 'appName', },
  { path: 'forbidden', component: ForbiddenComponent, title: 'appName', },
  { path: 'callback', component: CallbackComponent, title: 'appName', },
  { path: '**', redirectTo: 'home'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
